import { render, staticRenderFns } from "./form-rms-object.vue?vue&type=template&id=c9a163ba&scoped=true"
import script from "./form-rms-object.vue?vue&type=script&lang=js"
export * from "./form-rms-object.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a163ba",
  null
  
)

export default component.exports